<template>
    <div>
    <div class="layout-contents" v-if="!pending">
        <div class="box-container" data-size-to-fit>
            <div class="box-container-header">
                <h2 class="box-title">{{ $t('COMPLIANCE.LABEL.BASIC_INFORMATION')}}<!--기본 정보--></h2>
            </div>
            <table class="tbl-basic-info">
                <colgroup>
                    <col style="width: 300px;">
                    <col>
                </colgroup>
                <tbody>
                <tr>
                    <th scope="row">
                        {{ $t('LABEL.APPLIED_ON')}}<!--적용일-->
                    </th>
                    <td>
                        <time datetime="">{{ cmplDetail.aplyDt ? convertUtcTimezoneToLocal(cmplDetail.aplyDt) : ''}}</time>
                        <span class="seperate">{{cmplDetail.aplyUserNm}}</span>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        {{ $t('COMPLIANCE.LABEL.LAST_EVALUATED_ON')}}<!--최근 검사일-->
                    </th>
                    <td v-if="cmplDetail.execDt">
                        <time datetime="">{{cmplDetail.execDt ?  convertUtcTimezoneToLocal(cmplDetail.execDt) : ''}}</time>
                        <span class="seperate">{{cmplDetail.execUserNm}}</span>
                    </td>
                    <td v-else>
                        <span> {{$t('COMPLIANCE.RESULT.NEVER_RUN_EVALUATION_0')}} </span>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        {{ $t('LABEL.DESCRIPTION')}}<!--설명-->
                    </th>
                    <td>
                        {{cmplDetail.userDefiYn===constants.PARAM.SELECT.N ?cmplDetail[`${$i18n.locale}Desc`]: cmplDetail.desc}}
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        {{ $t('COMPLIANCE.LABEL.AUTOMATIC_EVALUATION')}}<!--자동 검사-->

                        <input v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" type="checkbox" id="schedule" name="schedule" class="switch-control"
                               v-bind:checked="cmplDetail.execType && cmplDetail.execType === 'A'" @change="changeExecuteType($event)">
                        <label v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" for="schedule"><span>schedule</span></label>
                    </th>
                    <td>
                        <time v-if="cmplDetail.execType && cmplDetail.execType === 'A'" datetime="">{{$t('COMPLIANCE.LABEL.NEXT_EVALUEATION')}} {{cmplDetail.reservedDate}}</time>
                        <time v-else datetime="" disabled>{{$t('COMPLIANCE.DETAIL.SET_SCHEDULE')}}</time>
                        <button v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" type="button" class="buttons-icon"
                            data-type="line"
                            data-size="s"
                            data-icon="setting"
                            @click="openAddSchePopup"><!-- 스케줄 -->
                        </button>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <div>
                            <label for="btnAcc">{{ $t('COMPLIANCE.LABEL.EVALUATION_SCOPE')}}<!--검사 범위--> (<em v-if="acntList != null">{{acntListCnt}}</em>)</label>
                            <button v-if="getMenuAuth === constants.AUTH_TYPE.EDIT"
                                id="btnAcc"
                                class="buttons-icon"
                                data-type="line"
                                data-size="s"
                                data-icon="setting"
                                title="검사 범위 설명"
                                @click="openAccountListPopup">{{ $t('COMPLIANCE.BUTTON.SET_EVAL_SCOPE')}}
                            </button>
                        </div>
                    </th>
                    <td>
                        <div class="toggle-accounts account" >
                            <div class="accounts" v-if="acntList != null && acntList.length > 0" :data-expand="isAccuntOpen ? true : null">
                                <span class="icon-tag" data-type="account"
                                      v-for="(acc, idx) of acntList" v-bind:data-deleted="acc.delYn === 'Y' ? true : null" :key="idx">
                                    <span :data-vendor="Common.getVendorByKey(acc.vendor)" class="icon-vender" data-size="s"></span>
                                    {{ acc.accId }}({{ acc.accAlias }}
                                </span>
                            </div>
                            <div v-else>
                                {{$t('COMPLIANCE.DETAIL.NONE_ACCOUNT')}}
                            </div>
                            <button v-if="isAccountView" type="button" class="txt-status btn-toggle-accounts" data-status="key" v-on:click="openAccountSection()">
                                <span class="expand"> {{$t('COMPLIANCE.DETAIL.EA_MORE', {cnt : remainerCnt})}}</span>
                                <span class="collapse">{{ $t('COMMON.BUTTON.CAMEL.COLLAPSE')}}<!--접기--></span>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <div>
                            <label for="btnRegion">{{ $t('COMPLIANCE.LABEL.EVALUATION_REGION')}}<!--검사 범위--> (<em v-if="preSlctedItem != null">{{preSlctedItem.length}}</em>)</label>
                            <button v-if="getMenuAuth === constants.AUTH_TYPE.EDIT"
                                id="btnRegion"
                                class="buttons-icon"
                                data-type="line"
                                data-size="s"
                                data-icon="setting"
                                title="검사 범위 설명"
                                @click="openRegionPopup">{{ $t('COMPLIANCE.BUTTON.SET_EVAL_SCOPE')}}
                            </button>
                        </div>
                    </th>
                    <td>
                        <div class="toggle-accounts list-region" >
                            <div class="accounts" v-if="preSlctedItem != null && preSlctedItem.length > 0" :data-expand="isRegionOpen ? true : null">
                                <span class="icon-tag" data-type="account"
                                      v-for="(region, idx) of preSlctedItem" :key="idx">
                                    <span :data-vendor="Common.getVendorByKey(region.vendor)" class="icon-vender" data-size="s"></span>
                                    {{ region.rgnNm }}
                                </span>
                            </div>
                            <div v-else>
                                {{$t('COMPLIANCE.DETAIL.NONE_REGION')}}
                            </div>
                            <button v-if="isRegionView" type="button" class="txt-status btn-toggle-accounts" data-status="key" v-on:click="openRegionSection()">
                                <span class="expand"> {{$t('COMPLIANCE.DETAIL.EA_MORE', {cnt : remainerReg})}}</span>
                                <span class="collapse">{{ $t('COMMON.BUTTON.CAMEL.COLLAPSE')}}</span>
                            </button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="box-container" data-size-to-fit data-round-top>
            <div class="box-container-header">
                <h2 class="box-title">{{ $t('COMPLIANCE.LABEL.WHITELIST')}}<!--화이트리스트--></h2>
                <div v-if="getMenuAuth === constants.AUTH_TYPE.VIEW" class="actions">
                    <router-link to="/settings/whitelist" class="buttons" data-type="ghost" data-size="s" data-icon-right="open">
                        <span class="open">{{ $t('COMPLIANCE.BUTTON.GO_TO_WHITELIST')}}<!--화이트리스트로 이동--></span></router-link>
                </div>
            </div>

            <div v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="tbl-actions">
                <span class="seperate">
                    <button type="button" class="buttons" data-type="line" data-size="s" data-icon="delete" data-trigger="delete-resource"
                            :disabled="wlDelList.length === 0"
                            @click="deleteWhitelist"
                    >{{ $t('COMPLIANCE.BUTTON.REMOVE_FROM_LIST')}}<!--목록에서 제거--></button>
                </span>
                <button class="buttons"
                    data-size="s"
                    data-icon="add"
                    data-trigger="add-resource"
                    @click="openWhitelistPopup"
                >{{ $t('COMPLIANCE.BUTTON.ADD_TO_WHITELIST')}}<!--화이트리스트에 추가--></button>
                <div class="actions">
                    <router-link to="/settings/whitelist" class="buttons" data-type="ghost" data-size="s" data-icon-right="open">
                        <span class="open">{{ $t('COMPLIANCE.BUTTON.GO_TO_WHITELIST')}}<!--화이트리스트로 이동--></span></router-link>
                </div>
            </div>
        </div>
        <CmplWhiteList 
            :menuAuth="getMenuAuth"
            :whiteListPending="whiteListPending"
            :whiteListItems="whiteList"
            :slctedAppliedWL="wlDelList"
            :sortColumn="wlSortColumn"
            :sortOrder="sortOrder"
            :callCheckAll="checkAllAppliedWL"
            :callSlctAppliedWL="setAppliedWL"
            :callSetSortColumn="setSortColumn"
        />
    </div>
    <div-loading v-else :full="true"></div-loading>
    <Modal
        ref="plcySingleModal"
        :okFunction="handleModalOkFunc"
        :callOnHide="handleHideModal"
        :title="modal.popupTitle"
        :message="modal.popupMessage"
        :isShowPopup="modal.isShowPopup"
        :btnOkStyle="modal.btnOkStyle"
        :modalClass="modal.modalClass"
        :modalSize="modal.modalSize"
        :isOkDisabled="modal.disableOk"
    >
        <template slot=body-template>
            <TabInfoSchedule v-if="modal.popupType === 'addSchePopup'" class="mt-4"
                :cmplId="cmplDetail.cmplId"
                :callSetScheInfo="setScheInfo"
            />
        </template>
        <template v-if="modal.popupType === 'accList'" slot=body-template>
            <GroupSelect class="mt-4"
                id="account-select"
                :options="cmplAcntList"
                :callGetValue="setSelectedAcntList"
                :preSlctedValue="selectedCmplAccList"
                :headTitle="$t('COMPLIANCE.LABEL.ASSESSMENT_ACCOUNT')"
                key="account-select"
            />
        </template>
        <template v-if="modal.popupType === 'whiteList'" slot=body-template>
            <AddToWhiteListForm class="mt-4"
                :allWtlList="allWtlList"
                :checkWtlList="checkWtlList"
                :callSetSearchText="setWLSearchText"
                :callSetCheckedWhiteList="setCheckedWhiteList"
            />
        </template>
        <!-- on development -->
        <template v-if="modal.popupType === 'regionPopup'" slot=body-template>
            <GroupSelect class="mt-4"
                id="region-select"
                :options="treeOptions"
                :callGetValue="getTreeValue"
                :preSlctedValue="preSlctedValue"
                :headTitle="$t('COMPLIANCE.LABEL.ASSESSMENT_REGION')"
                key="region-select"
            />
        </template>
    </Modal>
    </div>
</template>

<script>
    import { EventBus} from "../common/event-bus";
    import {mapGetters} from "vuex";
    import Modal from "../common/Modals/Modal.vue";
    import TabInfoSchedule from "./components/TabInfoSchedule.vue";
    import SetCmplAcntForm from "./components/SetCmplAcntForm.vue";
    import AddToWhiteListForm from "./components/AddToWhiteListForm.vue"
    import CmplWhiteList from './components/CmplWhiteList.vue';
    import GroupSelect from '../common/GroupSelect/GroupSelect.vue'
    export default {
        name: 'ComplianceDetailTabInfo',
        components: {
            Modal,
            TabInfoSchedule,
            SetCmplAcntForm,
            AddToWhiteListForm,
            CmplWhiteList,
            GroupSelect
        },
        data(){ // data = 변수 선언 부분
            return {
                regionSetting: [],
                treeValue: [],
                preSlctedValue: [],
                treeOptions: [],
                wlDelList: [],
                originAcntList: [],
                originSlctAcntList: [],
                selectedCmplAccList: [],
                cmplAcntList: [],
                cmplScheInfo: {},
                modal: {
                    isShowPopup: false
                },
                cmplDetail:{},

                wtlList:[],
                wtlListCnt:0,
                wlSortColumn: '',                                // Sort column
                sortOrder: '',                                 // Sort order

                originAllWtlList:[],
                allWtlList:[],
                searchTxt:'',
                checkWtlList:[],

                acntList:[],
                acntListCnt:0,
                allAcntList:[],
                pending: false,
                whiteListPending: false,

                isAccuntOpen: false, // account section data-expand
                isAccountView : false, // account more button
                remainerCnt: 0,
                cmplScheInfo: {},
                preSlctedItem : [],
                isRegionOpen : false,
                isRegionView: false,
                remainerReg: 0,
                cmplId: this.$route.query.cmpl
            }
        },
        created: function () {
            this.getCompliantDetailInfo();
            this.getAccountList();
            this.selectAppliedWhiteList();
            this.getRegions();
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId',
                menuAuth: "getMenuAuth"
            }),
            getMenuAuth() {
                //메뉴 별 권한
                let auth = _.find(this.menuAuth, {menuId: this.constants.MENU.COMPLIANCE_ASSESSMENT})
                return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
            },
            getLocale: function() {
                return this.$i18n.locale
            },
            whiteList: function(){
                let self = this;
                let list = this.wtlList;

                // Sorting 처리
                if (this.wlSortColumn !== '' && this.sortOrder !== '') {
                    list = _.orderBy(list, [wtl=> (wtl[self.wlSortColumn] != null && typeof(wtl[self.wlSortColumn]) !== 'number') ? wtl[self.wlSortColumn].toLowerCase() : wtl[self.wlSortColumn]], [self.sortOrder])
                }
                return list.length >0 ? list : [];
            }
        },
        watch:  {
            treeValue(value) {
                if (this.modal.popupType === "regionPopup") {
                    if (value.length === 0) {
                        this.modal.disableOk = true;
                    }
                }
            },
            selectedCmplAccList(newVal, olv) {
                if (_.isEqual(newVal, this.originSlctAcntList)) {
                    this.modal.disableOk = true;
                } else {
                    this.modal.disableOk = false;
                }

                if (newVal.length === 0) {
                    this.modal.disableOk = true;
                }
            },
            curCmpnId: function() {
                this.$router.push(`/compliance`);
            }
        },
        methods: {
            checkShowMoreRgn() {
                this.isRegionView = false;
                let self = this;
                // 더보기 처리
                setTimeout(function(){
                    let regionList = $('.list-region span[data-type=account]');
                    let topPosition;
                    self.remainerReg = 0;

                    $('.list-region span[data-type=account]').each(function(idx, item) {
                        let currentPosition = item.getBoundingClientRect().top;
                        if (topPosition && topPosition != currentPosition) {
                            self.remainerReg = regionList.length - idx;
                            self.isRegionView = true;
                            return false;
                        }
                        topPosition = currentPosition;
                    });
                },500)
            },
            getPresetRegion(regions) {
                this.preSlctedValue = [];
                this.preSlctedItem = [];
                regions.forEach((region)=>{
                    if (region.checked == 'Y') {
                        this.preSlctedValue.push(region.rgnId);
                        this.preSlctedItem.push(region);
                    }
                })
            },
            createRegionUpdate() {
                const rgnUpdate = [];
                const self = this;
                this.preSlctedItem = [];
                this.regionSetting.forEach((region)=>{
                    const rgn = {
                        vendor: region.vendor,
                        rgnId: region.rgnId,
                        rgnNm: region.rgnNm,
                        checked: "N"
                    };
                    if (self.treeValue.indexOf(region.rgnId) != -1) {
                        rgn.checked = "Y";
                        _.remove(self.treeValue, (value)=>{return value === region.rgnId});
                        this.preSlctedItem.push(rgn);
                    }
                    rgnUpdate.push(rgn);
                })
                this.checkShowMoreRgn();
                return rgnUpdate;
            },
            setAssessmentRegion() {
                const regions = this.createRegionUpdate();
                const url = "/api/governance/cmpl/all/region/change";
                const header = {
                    cmplId: this.cmplId,
                    cmpnId: this.curCmpnId,
                    regions,
                };
                try {
                    this.http.post(url, JSON.stringify(header));
                } catch(err) {
                    console.error("getRegions: ", err);
                } finally {
                    this.pending = false;
                }
            },
            getTreeValue(value) {
                this.treeValue = value;
            },
            createTreeRegion(regions) {
                this.regionSetting = regions;
                let vendors = regions.map(item=>{return item.vendor});
                vendors = _.union(vendors);
                const tree = [];
                vendors.forEach((vendor)=>{
                    let children = regions.filter(vnode => vnode.vendor === vendor);
                    children = children.map(item=>{return {id: item.rgnId, label: item.rgnNm}});
                    tree.push({id: vendor, label: this.Common.getShortName(vendor), children});
                });
                this.treeOptions = tree;
            },
            async getRegions() {
                const url = "/api/governance/cmpl/all/region";
                const header = {
                    "cmplId": this.cmplId,
                };
                try {
                    const response = await this.http.post(url, JSON.stringify(header));
                    if (response.data.status === 'ok') {
                        this.createTreeRegion(response.data.result);
                        this.getPresetRegion(response.data.result);
                        this.$nextTick(function () { 
                            this.checkShowMoreRgn();
                        });
                    }
                } catch(err) {
                    console.error("getRegions: ", err);
                } finally {
                    this.pending = false;
                }
            },
            async openRegionPopup() {
                await this.getRegions();
                this.modal = {
                    popupTitle: this.$t('COMPLIANCE.BUTTON.SET_EVAL_REGION'),
                    popupMessage: this.$t('REGION.MESSAGE.MAIN_DESC'),
                    isShowPopup: true,
                    popupType: 'regionPopup',
                    disableOk: false,
                    modalClass: "default-modal"
                }
            },
            setAppliedWL(sltedWhiteList) {
                this.wlDelList = sltedWhiteList;
            },
            setCheckedWhiteList(sltedWhiteList, isDisableOK) {
                this.checkWtlList = sltedWhiteList;
                this.modal.disableOk = isDisableOK;
            },
            setWLSearchText(searchTxt) {
                this.allWtlList = _.filter(this.originAllWtlList, function (o) {
                    return o.titl.toLowerCase().includes(searchTxt.toLowerCase());
                });
            },
            async openWhitelistPopup() {
                await this.selectAppliedWhiteList();
                await this.getAllWhitelistInfo();
                this.modal = {
                    popupTitle: this.$t('COMPLIANCE.POPUP.TITLE.SET_WHITELIST'),
                    popupMessage: this.$t('COMPLIANCE.POPUP.DESC.SET_WHITELIST'),
                    isShowPopup: true,
                    popupType: 'whiteList',
                    disableOk: true,
                    modalSize: "lg"
                }
            },
            async getCmplAcntList(cmplId) {
                const url = "/api/governance/cmpl/all/acnt";
                const header = {
                    cmpnId: this.curCmpnId,
                    cmplId
                };
                const result = await this.http.post(url, JSON.stringify(header))
                if(result.status === 200){
                    this.originAcntList = result.data.result.list;

                    let vendors = this.originAcntList.map(item=>{return item.vendor});
                    vendors = _.union(vendors);
                    const tree = [];
                    vendors.forEach((vendor)=>{
                        let children = this.originAcntList.filter(vnode => vnode.vendor === vendor);
                        children = children.map(item=>{return {id: item.accId, label: item.accAlias}});
                        tree.push({id: (vendor || '').toLowerCase(), label: this.Common.getShortName(vendor), children});
                    });
                    this.cmplAcntList = tree;

                    let checkAcntList = [];
                    this.originAcntList.forEach((o) => {
                        if (o.mappingYn === 1) {
                            checkAcntList.push(o.accId);
                        }
                    });
                    this.originSlctAcntList = _.cloneDeep(checkAcntList);
                    this.selectedCmplAccList = checkAcntList;
                }
            },
            async openAccountListPopup() {
                await this.getCmplAcntList(this.cmplId);
                this.modal = {
                    popupTitle: this.$t('COMPLIANCE.BUTTON.SET_EVAL_SCOPE'),
                    popupMessage: this.$t('SCOPE.MESSAGE.MAIN_DESC'),
                    isShowPopup: true,
                    popupType: 'accList',
                    disableOk: true,
                    modalClass: "default-modal"
                }
            },
            setSelectedAcntList(selectedList) {
                this.selectedCmplAccList = selectedList;
            },
            openAddSchePopup() {
                this.cmplScheInfo = {
                    "peri": "D",
                    "day": null,
                    "dt": "00:00",
                    "browserTimeZone": moment().format('Z'),
                    "cmpnId": this.curCmpnId,
                    "cmplId": this.cmplId
                },
                this.modal = {
                    isShowPopup: true,
                    popupType: 'addSchePopup',
                    popupTitle: this.$t('COMPLIANCE.BUTTON.SET_SCHEDULE'),
                    popupMessage: this.$t('POLICY.ADD_POPUP.CREATE_SCHEDULE'),
                }
            },
            setScheInfo(scheInfo) {
                this.cmplScheInfo = {...this.cmplScheInfo, ...scheInfo};
            },
            handleHideModal() {
                if (this.modal.popupType === "addSchePopup") {
                    this.cmplScheInfo = {};
                } else if (this.modal.popupType === "accList") {
                    this.selectedCmplAccList = [];
                }
                this.modal.isShowPopup = false;
            },
            handleModalOkFunc() {
                if (this.modal.popupType === "addSchePopup") {
                    this.changeSchedule();
                } else if (this.modal.popupType === "accList") {
                    this.changeCmplAccounts();
                } else if (this.modal.popupType === "whiteList") {
                    this.changeWhitelist();
                } else if (this.modal.popupType === "regionPopup") {
                    this.setAssessmentRegion();
                }
            },
            convertUtcTimezoneToLocal: function(date) {
                return this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale);
            },
            // Compliance 기본 정보 조회
            async getCompliantDetailInfo() {
                this.pending = true;
                let url = "/api/governance/cmpl/detail";
                let header = {
                    "cmpnId": this.curCmpnId,
                    "cmplId": this.cmplId
                };
                const result = await this.http.post(url, JSON.stringify(header))
                if (result.status === 200) {
                    this.cmplDetail = result.data.result;
                    this.$emit('sheduleChange', this.cmplDetail.execType, this.cmplDetail.reservedDate);
                }
                this.pending = false;
            },
            // 검사 범위 account 조회
            getAccountList: function () {
                let url = `/api/governance/cmpl/target/acnt`;
                let header = {
                    "cmpnId": this.curCmpnId,
                    "cmplId":this.cmplId
                };

                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        if(result.status === 200){
                            this.acntList = result.data.result.list ? result.data.result.list : [] ;
                            this.acntListCnt = result.data.result.cnt;

                            this.$nextTick(function () { // TODO :: 툴팁 스크립트 추가해야할듯
                                let self = this;
                                // 더보기 처리
                                setTimeout(function(){
                                    let acntList = $('.account span[data-type=account]');
                                    let topPosition;
                                    self.remainerCnt = 0;

                                    $('.account span[data-type=account]').each(function(idx, item) {
                                        let currentPosition = item.getBoundingClientRect().top;
                                        if (topPosition && topPosition != currentPosition) {
                                            self.remainerCnt = acntList.length - idx;
                                            self.isAccountView = true;
                                            return false;
                                        }
                                        topPosition = currentPosition;
                                    });
                                },1000)
                            });
                        }
                    });
            },
            async changeCmplAccounts() {
                const url = "/api/governance/cmpl/target/acnt/change";
                const header = {
                    cmpnId: this.curCmpnId,
                    prntsObjId: this.cmplId,
                    objIdList: this.selectedCmplAccList
                };

                const result = await this.http.post(url, JSON.stringify(header))
                if(result.status === 200){
                    this.getAccountList();
                }
            },
            // 상세 화면의 whitelist 목록 조회
            async selectAppliedWhiteList() {
                const url = "/api/governance/cmpl/target/whitelist";
                const header = {
                    "cmpnId": this.curCmpnId,
                    "cmplId": this.cmplId
                };
                this.whiteListPending = true;
                const result = await this.http.post(url, JSON.stringify(header));
                if(result.status === 200){
                    this.wtlList = result.data.result.list;
                    this.checkWtlList = this.wtlList.map(wl=>wl.wtlId);
                    this.wtlListCnt = result.data.result.cnt;
                    this.whiteListPending = false
                }
            },
            // 추가 팝업의 whitelist 목록 조회 with mapping 여부
            async getAllWhitelistInfo() {
                this.searchTxt = '';
                const url = "/api/governance/cmpl/all/whitelist";
                const header = {
                    "cmpnId": this.curCmpnId,
                    "cmplId" : this.cmplId
                };
                const result = await this.http.post(url, JSON.stringify(header));
                if (result.status === 200) {
                    this.originAllWtlList = result.data.result.list;
                    this.allWtlList = _.cloneDeep(this.originAllWtlList);
                }
            },
            // 추가 팝업의 저장
            async changeWhitelist() {
                this.whiteListPending = true;
                const url = "/api/governance/cmpl/target/whitelist/change";
                const header = {
                    cmpnId: this.curCmpnId,
                    prntsObjId: this.cmplId,
                    objIdList: this.checkWtlList
                };
                const result = await this.http.post(url, JSON.stringify(header));
                if (result.status === 200) {
                    this.selectAppliedWhiteList();
                }
            },
            // whitelist 목록에서 삭제
            async deleteWhitelist () {
                this.whiteListPending = true;
                const url = "/api/governance/cmpl/target/whitelist/delete";
                const header = {
                    cmpnId: this.curCmpnId,
                    prntsObjId: this.cmplId,
                    objIdList: this.wlDelList
                };

                const result = await this.http.post(url, JSON.stringify(header));
                if(result.status === 200){
                    this.selectAppliedWhiteList();
                    this.wlDelList = [];
                }
            },
            // 선택한 Column으로 Rule 리스트 Sorting
            setSortColumn(targetColumn) {
                const sortResult = this.Common.setSortColumn(this.wlSortColumn, this.sortOrder, targetColumn);
                this.wlSortColumn = sortResult.sortColumn;
                this.sortOrder = sortResult.sortOrder;
            },
            changeExecuteType(event) {
                let url = `/api/governance/cmpl/excution/update`;
                if (this.cmplDetail.reservedDate == null) {
                    return;
                }
                let execType = event.target.checked ? 'A' : 'M';
                this.$emit('sheduleChange', execType);
                this.cmplDetail.execType = execType;
                let header = {
                    "cmpnId": this.curCmpnId,
                    "cmplId":this.cmplId,
                    "execType":execType
                };
                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        if(result.status === 200){
                            //this.getCompliantDetailInfo();
                        }
                    });

            },
            async changeSchedule() {
                this.pending = true;
                const url = "/api/governance/schedule/upsert";
                
                const result = await this.http.post(url, JSON.stringify(this.cmplScheInfo))
                if (result.data.status === 'ok') {
                    this.getCompliantDetailInfo();
                    EventBus.$emit('toastComment', 'POLICY.TOAST.SET_SCHEDULE');
                }
                this.pending = false;
            },
            checkAllAppliedWL(isAll) {
                if (isAll && this.cmplAcntList) {
                    this.wlDelList = this.whiteList.map(wl=>wl.wtlId);
                } else {
                    this.wlDelList = [];
                }
            },
            openAccountSection(){
                this.isAccuntOpen = !this.isAccuntOpen
            },
            openRegionSection(){
                this.isRegionOpen = !this.isRegionOpen
            }
        }
    }
</script>
<style scoped>
/deep/ .vue-treeselect__multi-value {
    max-height: 100px;
    overflow: auto;
}
.region {
    margin: 5px 5px 5px 0;
    cursor: pointer;
    background: #e3f2fd;
    display: inline-block;
    padding: 2px;
    border: 1px solid transparent;
    border-radius: 2px;
    color: #039be5;
    font-size: 12px;
}
.toggle-accounts .accounts[data-expand] {
    max-height: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/compliance/complianceDetailTabInfo.vue